import { SIGNAL_TYPE_COLORS } from '../types';

interface SignalBadgeProps {
  type: string;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export default function SignalBadge({ type, showLabel = true, size = 'md' }: SignalBadgeProps) {
  const colors = SIGNAL_TYPE_COLORS[type] || { bg: 'bg-gray-500/20', text: 'text-gray-400', emoji: '⚪' };

  const sizeClasses = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';

  const labels: Record<string, string> = {
    SHARP_VS_SQUARE: 'Sharp vs Square',
    STEAM_MOVE: 'Steam Move',
    CONSENSUS_DIVERGENCE: 'Consensus Div',
    OPENING_VS_CURRENT: 'Opening vs Current',
    ARBITRAGE: 'Arbitrage',
    CLV_POSITIVE: 'CLV Positive',
    VOLUME_SPIKE: 'Volume Spike',
  };

  return (
    <span className={`inline-flex items-center gap-1 rounded ${colors.bg} ${colors.text} ${sizeClasses}`}>
      <span>{colors.emoji}</span>
      {showLabel && <span>{labels[type] || type}</span>}
    </span>
  );
}
